<template>
    <div>
        <CultureTop />
        <div class="titleStyle">
            <div class="titleFont">企业文化核心</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">CORE OF CORPORATE CULTURE</span>
                <div class="divide"></div>
            </div>
        </div>
        <div class="corporateCulturesList">
            <div class="listItem" v-for="(item, idx) in infoList" :key="idx">
                <div class="itemTitle">{{ item.title }}</div>
                <div class="itemLine"></div>
                <div class="itemContent">
                    {{ item.description }}
                </div>
                <!-- <div class="imgDiv" v-if="idx != 1">
                    <img src="@/assets/culture/test.png" alt="" />
                </div>
                <div class="listContent">
                    <div class="listContentTitle">{{ item.title }}</div>
                    <div class="listContentDescription">
                        {{ item.description }}
                    </div>
                </div>
                <div class="imgDiv" v-if="idx == 1">
                    <img src="@/assets/culture/test.png" alt="" />
                </div> -->
            </div>
        </div>
        <div class="corporateCulturesBottom">
            <div class="itemOne">
                <div class="opacityImg">
                    <img
                        src="../../assets/culture/managementPhilosophy.png"
                        class="itemImg"
                    />
                </div>
                <div class="itemContent">
                    <div class="itemTitle">管理理念</div>
                    <div class="itemContent">“以人为本，无为而治”</div>
                </div>
            </div>
            <div class="itemOne">
                <div class="opacityImg">
                    <img
                        src="../../assets/culture/bossmanship.png"
                        class="itemImg"
                    />
                </div>
                <div class="itemContent">
                    <div class="itemTitle">企业精神</div>
                    <div class="itemContent">
                        “求实、务实、提高办事效率，参与市场竞争”
                    </div>
                </div>
            </div>
            <div class="itemOne">
                <div class="opacityImg">
                    <img
                        src="../../assets/culture/enterpriseTenet.png"
                        class="itemImg"
                    />
                </div>
                <div class="itemContent">
                    <div class="itemTitle">企业宗旨</div>
                    <div class="itemContent">“用户第一、信誉至上”</div>
                </div>
            </div>
            <div class="itemOne">
                <div class="opacityImg">
                    <img
                        src="../../assets/culture/corporationVision.png"
                        class="itemImg"
                    />
                </div>
                <div class="itemContent">
                    <div class="itemTitle">企业愿景</div>
                    <div class="itemContent">
                        “大宗与建材领域综合物流服务商”
                    </div>
                </div>
            </div>
            <div class="itemTwo">
                <div class="opacityImg">
                    <img
                        src="../../assets/culture/employmentPrinciple.png"
                        class="itemImg"
                    />
                </div>
                <div class="itemContent">
                    <div class="itemTitle">服务准则</div>
                    <div class="itemContent">
                        “诚信务实、专注服务、安全高效”
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CultureTop from "@/components/CultureTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "CorporateCultures",
    components: {
        CultureTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryIndexEnterpriseCultureList",
            infoList: [],
        };
    },
    created() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            let that = this;
            getAction(that.url).then((res) => {
                if (res.code == 200 && res.success) {
                    that.infoList = res.result.records;
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    width: 100%;
    text-align: center;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.corporateCulturesList {
    .typeArea();
    display: flex;
    justify-content: space-between;
    margin-bottom: 100px;
    .listItem {
        width: 353px;
        padding: 49px 37px;
        background-color: #fbfbfb;
        display: flex;
        flex-direction: column;
        .itemTitle {
            font-family: "优设标题黑";
            font-size: 32px;
            line-height: 34px;
            letter-spacing: 0px;
            color: #333333;
            margin-bottom: 18px;
        }
        .itemLine {
            width: 90px;
            height: 4px;
            background-color: #0052d9;
        }
        .itemContent {
            margin-top: 34px;
            font-size: 18px;
            letter-spacing: 0px;
            color: #666666;
        }
        // display: flex;
        // .imgDiv {
        //     width: 50%;
        //     img {
        //         width: 100%;
        //         height: 220px;
        //     }
        // }
        // .listContent {
        //     width: 50%;
        //     padding: 40px 50px;
        //     background: rgba(235, 238, 240, 1);
        //     font-family: "黑体";
        //     color: black;
        //     font-weight: 400;
        //     .listContentTitle {
        //         font-size: 32px;
        //         margin-bottom: 30px;
        //     }
        //     .listContentDescription {
        //         font-size: 18px;
        //     }
        // }
    }
    .listItem:hover {
        box-shadow: 0px 16px 40px 0px rgba(0, 0, 0, 0.2);
    }
}
.corporateCulturesBottom {
    display: flex;
    flex-wrap: wrap;
    .itemContent {
        z-index: 2;
        text-align: center;
        .itemTitle {
            margin-bottom: 30px;
            font-family: "优设标题黑";
            font-size: 30px;
            color: #ffffff;
        }
        .itemContent {
            font-size: 18px;
            letter-spacing: 0px;
            color: #ffffff;
        }
    }
    .itemOne {
        flex-grow: 1;
        width: 30%;
        height: 340px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .opacityImg {
            background-color: rgba(0, 0, 0);
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            .itemImg {
                opacity: 0.2;
                width: 100%;
                height: 100%;
            }
        }
    }
    .itemOne:nth-child(4) {
        flex-grow: 0.5;
    }
    .itemTwo {
        flex-grow: 1;
        width: 60%;
        height: 340px;
        background-image: linear-gradient(155deg, #26314c 0%, #000000 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        .opacityImg {
            background-color: rgba(0, 0, 0);
            position: absolute;
            z-index: 1;
            width: 100%;
            height: 100%;
            .itemImg {
                opacity: 0.2;
                width: 100%;
                height: 100%;
            }
        }
    }
    .itemTwo:hover,
    .itemOne:hover {
        .opacityImg {
            background: #0052d9;
        }
    }
}
</style>
